import { render, staticRenderFns } from "./SessionDetail.vue?vue&type=template&id=6fe1a0a8&"
import script from "./SessionDetail.vue?vue&type=script&lang=ts&"
export * from "./SessionDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports